/**
 * Wallet Pass Service
 * Issues and serves Apple Wallet and Google Wallet loyalty passes for Convercus programs. Internal administrators register programs, mint program API keys, maintain store locations, configure wallet design and levels, read adoption analytics and query the audit trail; customer-facing clients download a pass through the program-scoped download routes, and the wallets themselves keep it current through the Apple PassKit web service and the Google Wallet Objects callback. Every path below already carries the gateway base prefix `/wallet-pass-service`.
 *
 * The version of the OpenAPI document: 1.0.39938
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DesignPreviewIntegrationSummaryDto } from './design-preview-integration-summary-dto';
import { DesignPreviewAppearanceDto } from './design-preview-appearance-dto';
import { DesignPreviewFormFieldAvailabilityDto } from './design-preview-form-field-availability-dto';
import { DesignPreviewAnnotationDto } from './design-preview-annotation-dto';
import { DesignPreviewScannableDto } from './design-preview-scannable-dto';


export interface DesignPreviewResponseDto { 
    convercusProgramId: string;
    integration: DesignPreviewResponseDto.IntegrationEnum | null;
    platform: DesignPreviewResponseDto.PlatformEnum;
    levelKey?: object | null;
    appearance: DesignPreviewAppearanceDto;
    scannableCode: DesignPreviewScannableDto;
    mockPayload: { [key: string]: object; };
    apple?: { [key: string]: object; };
    google?: { [key: string]: object; };
    annotations: Array<DesignPreviewAnnotationDto>;
    formFieldAvailability?: { [key: string]: DesignPreviewFormFieldAvailabilityDto; };
    integrationSummary?: DesignPreviewIntegrationSummaryDto | null;
}
export namespace DesignPreviewResponseDto {
    export type IntegrationEnum = 'toom' | 'gkr' | 'null';
    export const IntegrationEnum = {
        Toom: 'toom' as IntegrationEnum,
        Gkr: 'gkr' as IntegrationEnum,
        Null: 'null' as IntegrationEnum
    };
    export type PlatformEnum = 'ios' | 'android';
    export const PlatformEnum = {
        Ios: 'ios' as PlatformEnum,
        Android: 'android' as PlatformEnum
    };
}


